import { useState, useEffect } from "react";
import {
  Divider,
  Box,
  Button,
  IconButton,
  CardMedia,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import Detail from "../../main/detail/Detail";
import LandingPageAllContents from "./LandingPageAllContents";
import LandingPageContentRows from "./LandingPageContentRows";
import { rsActiveMenu, rsProgress, rsParentCom } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseLandingsPages } from "./UseLandingsPages";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../images/Content/Header1.png";
import Footer from "../../images/Content/Footer.png";
import RefreshIcon from "@mui/icons-material/Refresh";
import useBreakpoints from "../../hooks/useBreakpoints";
import EditIcon from "@mui/icons-material/Edit";
import { UseLandingHeader } from "./HeaderLanding/UseLandingHeader";
import { UseLandingFooter } from "./FooterCom/UseLandingFooter";
import DeleteIcon from "@mui/icons-material/Delete";
import { UseOffer } from "../firstPage/HomeOffer/UseOffer";

export default function LandingPageContent() {
  const { RemoveHeader } = UseLandingHeader();
  const { RemoveFooter } = UseLandingFooter();
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { GetLandingComponents, SetLandingComponents, removeLandingComponent } =
    UseLandingsPages();
  const [openDeleteDialog, setOpenDeleteDialog] = useState({
    show: false,
    id: undefined,
    type: undefined,
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [components, setComponents] = useState();
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const { isSmall } = useBreakpoints();
  const navigate = useNavigate();
  const { UpdateOffersDataAll, UpdateOffersAll } = UseOffer();

  useEffect(() => {
    if (msParentCom?.landingPageID) {
      setProgress(true);
      GetLandingComponents(msParentCom.landingPageID, (components) => {
        setComponents(components);
      });
    }
  }, [msParentCom]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/landingmanagment",
        normargin: true,
        title: "مدیریت محتوا",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/landingmanagment/landingComponents",
          },
        ],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDeleteDialog.show}
        onClose={() =>
          setOpenDeleteDialog({ ...openDeleteDialog, show: false })
        }
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          آیا از حذف این آیتم اطمینان دارید ؟
        </DialogTitle>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() => {
              if (openDeleteDialog.type == "Header") {
                RemoveHeader(openDeleteDialog.id, () => {
                  setOpenDeleteDialog({
                    show: false,
                    id: undefined,
                    type: undefined,
                  });

                  GetLandingComponents(
                    msParentCom.landingPageID,
                    (components) => {
                      setComponents(components);
                    }
                  );
                });
              } else {
                RemoveFooter(openDeleteDialog.id, () => {
                  setOpenDeleteDialog({
                    show: false,
                    id: undefined,
                    type: undefined,
                  });

                  GetLandingComponents(
                    msParentCom.landingPageID,
                    (components) => {
                      setComponents(components);
                    }
                  );
                });
              }
            }}
          >
            بله
          </Button>
          <Button
            color="secondary"
            onClick={() =>
              setOpenDeleteDialog({ ...openDeleteDialog, show: false })
            }
          >
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            backgroundColor: "#F5F5F5",
            height: "100%",
            py: 2,
          }}
        >
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                alignItems: "flex-end",
                position: "relative",
                width: isSmall ? "100%" : "60%",
                mx: "auto",
              }}
            >
              <CardMedia component="img" image={Header} />
              <Box
                sx={{
                  py: 1,
                  position: "absolute",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  zIndex: 1000,
                  right: 5,
                }}
              >
                <IconButton
                  onClick={(evt) => {
                    navigate("/landingmanagment/headerManage", {
                      state: {
                        id: msParentCom.landingPageID,
                      },
                    });
                  }}
                  sx={{
                    p: 0.7,
                    mr: 1,
                    bgcolor: "secondary.main",
                    "&:hover": {
                      boxShadow: 3,
                      bgcolor: "secondary.main",
                    },
                  }}
                >
                  <EditIcon fontSize="small" sx={{ fill: "#fff" }} />
                </IconButton>
                <IconButton
                  sx={{
                    p: 0.7,
                    bgcolor: "secondary.main",
                    "&:hover": {
                      boxShadow: 3,
                      bgcolor: "secondary.main",
                    },
                  }}
                  onClick={() => {
                    setOpenDeleteDialog({
                      show: true,
                      id: msParentCom.landingPageID,
                      type: "Header",
                    });
                  }}
                >
                  <DeleteIcon fontSize="small" sx={{ fill: "#fff" }} />
                </IconButton>
              </Box>
            </Box>
          </Box>
          <LandingPageContentRows
            callback={(tempRow) => {
              SetLandingComponents(tempRow, () => {
                GetLandingComponents(
                  msParentCom.landingPageID,
                  (components) => {
                    setComponents(components);
                  },
                  true
                );
              });
            }}
            callbackRemove={(AID) => {
              removeLandingComponent(AID, () => {
                GetLandingComponents(
                  msParentCom.landingPageID,
                  (components) => {
                    setComponents(components);
                  },
                  true
                );
              });
            }}
            row={components}
            setRow={setComponents}
          />
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{
                // mb: 2,
                display: "flex",
                alignItems: "flex-end",
                position: "relative",
                width: isSmall ? "100%" : "60%",
                mx: "auto",
              }}
            >
              <CardMedia component="img" image={Footer} />
              <Box
                sx={{
                  py: 1,
                  position: "absolute",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  zIndex: 1000,
                  right: 5,
                }}
              >
                <IconButton
                  onClick={(evt) => {
                    navigate("/landingmanagment/footerManage", {
                      state: {
                        id: msParentCom.landingPageID,
                      },
                    });
                  }}
                  sx={{
                    p: 0.7,
                    mr: 1,
                    bgcolor: "secondary.main",
                    "&:hover": {
                      boxShadow: 3,
                      bgcolor: "secondary.main",
                    },
                  }}
                >
                  <EditIcon fontSize="small" sx={{ fill: "#fff" }} />
                </IconButton>
                <IconButton
                  sx={{
                    p: 0.7,
                    bgcolor: "secondary.main",
                    "&:hover": {
                      boxShadow: 3,
                      bgcolor: "secondary.main",
                    },
                  }}
                  onClick={() => {
                    setOpenDeleteDialog({
                      show: true,
                      id: msParentCom.landingPageID,
                      type: "Footer",
                    });
                  }}
                >
                  <DeleteIcon fontSize="small" sx={{ fill: "#fff" }} />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
        >
          <Divider />
          {isSmall ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                p: 2,
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  sx={{ width: "100px" }}
                  variant="contained"
                  onClick={() => {
                    setOpenDialog(true);
                  }}
                >
                  آیتم جدید
                </Button>
                <Button
                  color="secondary"
                  sx={{ width: "100px" }}
                  variant="contained"
                  onClick={() => {
                    SetLandingComponents(components, () => {
                      GetLandingComponents(
                        msParentCom.landingPageID,
                        (components) => {
                          setComponents(components);
                        }
                      );
                    });
                  }}
                >
                  ثبت
                </Button>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  sx={{ width: "140px" }}
                  variant="contained"
                  onClick={() => {
                    setProgress(true);
                    UpdateOffersAll(() => setProgress(false));
                  }}
                >
                  به‌روزرسانی محصول
                </Button>
                <Button
                  sx={{ width: "140px" }}
                  variant="contained"
                  onClick={() => {
                    setProgress(true);
                    UpdateOffersDataAll(() => setProgress(false));
                  }}
                >
                  به‌روزرسانی داده
                </Button>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                p: 2,
                justifyContent: "space-between",
              }}
            >
              <Button
                sx={{ width: "100px" }}
                variant="contained"
                onClick={() => {
                  setOpenDialog(true);
                }}
              >
                آیتم جدید
              </Button>
              <Box>
                <Button
                  sx={{ width: "140px" }}
                  variant="contained"
                  onClick={() => {
                    setProgress(true);
                    UpdateOffersAll(() => setProgress(false));
                  }}
                >
                  به‌روزرسانی محصول
                </Button>
                <Button
                  sx={{ width: "140px", mx: 2 }}
                  variant="contained"
                  onClick={() => {
                    setProgress(true);
                    UpdateOffersDataAll(() => setProgress(false));
                  }}
                >
                  به‌روزرسانی داده
                </Button>
                <Button
                  color="secondary"
                  sx={{ width: "100px" }}
                  variant="contained"
                  onClick={() => {
                    SetLandingComponents(components, () => {
                      GetLandingComponents(
                        msParentCom.landingPageID,
                        (components) => {
                          setComponents(components);
                        }
                      );
                    });
                  }}
                >
                  ثبت
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
      {openDialog && (
        <LandingPageAllContents
          row={components}
          setRow={setComponents}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          components={components}
          callback={(tempRow) => {
            SetLandingComponents(tempRow, () => {
              GetLandingComponents(
                msParentCom.landingPageID,
                (components) => {
                  setComponents(components);
                },
                true
              );
            });
          }}
        />
      )}
    </Detail>
  );
}
